import React, { useState } from 'react';
import { FILTER_DROPDOWN_HEADERS } from 'src/constants/filterConstants.js';
import {
    FilterWrapperMain,
    FilterContentMain,
    FilterHeading,
    Reset,
    TextBold,
    FilterHeader,
    FilterBlock,
    EmptyBox,
} from './Filters.styled.jsx';
import BottomNavigation from 'src/common/refactoredComponents/bottomNavigation/BottomNavigation';
import Button from 'src/common/refactoredComponents/button/Button';
import { ButtonStyles } from 'src/constants/buttonStyles';
import Spinner from 'src/common/refactoredComponents/spinner/Spinner';
import { convertDateToISOString, logErrorToConsole } from 'src/utils/util';
import {
    getPreviousDate,
    addDaysToDate,
    isStartDateLessThanEndDate,
} from 'src/utils/dateUtils';
import FilterView from 'src/common/components/filter/FilterView';
import {
    setFilters,
    putFilterOptions,
    getCardData,
    getListData,
    getViewData,
    setSelectedCalendarView as setSelectedCalendarViewRedux,
    setExpandedFilterViews,
    getRefinedFilters,
    setViewDataEmpty,
    setOrderCondition,
} from 'src/pages/home/redux/actions';
import { useSelector, useDispatch, shallowEqual } from 'react-redux';
import { useTranslation } from 'react-i18next';
import useApplyButtonStatus from './hooks/useApplyButtonStatus.js';
import setSelectedCalendarViewhandler from './handlers/setSelectedCalendarViewhandler.js';
import CommonFilter from './CommonFilter';
import { useViewportHeight } from 'src/utils/useViewportHeight';
import { useEffectWithErrorLogging} from 'src/utils/useEffectWithErrorLogging';

const Filters = (props) => {
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const viewportHeight = useViewportHeight();
    //internal variables
    const [applyButton, setApplyButton] = useState(false);
    const [checkOrderCondition, setCheckOrderCondition] = useState(false);
    const orderCondition = useSelector(
        (state) => state.appliedFiltersReducer.displayOrderCondition
    );
    const [allFiltersWithStatus, setAllFiltersWithStatus] = useState({
        orderTypesFilter: [],
        accountFilter: [],
        orderStatusFilter: [],
        physicianFilter: [],
        procedureFilter: [],
        orderConditionFilter: [
            {
                id: 'assignedFlag',
                name: t('calendar.filterResultsPanel.assigned'),
                selected: orderCondition,
            },
            {
                id: 'unAssignedFlag',
                name: t('calendar.filterResultsPanel.unassigned'),
                selected: !orderCondition,
            },
        ],
    });
    const [allCalendarViewFilters, setAllCalendarViewFilters] = useState([]);
    const [expandedViewsLocal, setExpandedViewsLocal] = useState({});

    // Values from reducers
    const expandedViews = useSelector(
        (state) => state.filterReducer.expandedFilterViews,
        shallowEqual
    );
    const selectedDate = useSelector(
        (state) => state.filterReducer.selectedDate
    );

    const refinedFilters = useSelector(
        (state) => state.refinedFiltersReducer,
        shallowEqual
    );

    refinedFilters.orderStatusFilter =
        refinedFilters?.orderStatusFilter[0]?.description !== 'All'
            ? [
                  {
                      description: 'All',
                      isChecked: false,
                      statusCode: 'All',
                  },
                  ...refinedFilters.orderStatusFilter,
              ]
            : refinedFilters.orderStatusFilter;
    refinedFilters.orderTypesFilter =
        refinedFilters?.orderTypesFilter[0]?.orderTypeName !== 'All'
            ? [
                  {
                      orderTypeCode: 'All',
                      orderTypeName: 'All',
                      isChecked: false,
                  },
                  ...refinedFilters.orderTypesFilter,
              ]
            : refinedFilters.orderTypesFilter;

    refinedFilters.physicianFilter =
        refinedFilters?.physicianFilter[0]?.physicianId !== 'physicianIdAll' &&
        refinedFilters?.physicianFilter.length > 0
            ? [
                  {
                      physicianId: 'physicianIdAll',
                      name: 'All',
                      isChecked: false,
                      isFavourite: false,
                  },
                  ...refinedFilters.physicianFilter,
              ]
            : refinedFilters.physicianFilter;

    refinedFilters.accountFilter =
        refinedFilters?.accountFilter[0]?.accountId !== 'accountIdAll' &&
        refinedFilters?.accountFilter.length > 0
            ? [
                  {
                      accountId: 'accountIdAll',
                      name: 'All',
                      isChecked: false,
                      isFavourite: false,
                  },
                  ...refinedFilters.accountFilter,
              ]
            : refinedFilters.accountFilter;

    refinedFilters.procedureFilter =
        refinedFilters?.procedureFilter[0]?.description !== 'All' &&
        refinedFilters?.procedureFilter.length > 0
            ? [
                  {
                      description: 'All',
                      isChecked: false,
                      procedureId: 'procedureIdAll',
                  },
                  ...refinedFilters.procedureFilter,
              ]
            : refinedFilters.procedureFilter;

    const appliedFilters = useSelector(
        (state) => state.appliedFiltersReducer,
        shallowEqual
    );

    if (appliedFilters.physiciansSelected.length === 0) {
        appliedFilters.physiciansSelected = [
            {
                physicianId: 'physicianIdAll',
                name: 'All',
                isChecked: true,
            },
            ...appliedFilters.physiciansSelected,
        ];
    }

    if (appliedFilters.orderTypesSelected.length === 0) {
        appliedFilters.orderTypesSelected = [
            {
                orderTypeCode: 'All',
                orderTypeName: 'All',
                isChecked: true,
            },
            ...appliedFilters.orderTypesSelected,
        ];
    }
    if (appliedFilters.orderStatusesSelected.length === 0) {
        appliedFilters.orderStatusesSelected = [
            {
                description: 'All',
                statusCode: 'All',
                isChecked: true,
            },
            ...appliedFilters.orderStatusesSelected,
        ];
    }

    if (appliedFilters?.accountsSelected?.length === 0) {
        appliedFilters.accountsSelected = [
            {
                accountId: 'accountIdAll',
                name: 'All',
                isChecked: true,
            },
            ...appliedFilters?.accountsSelected,
        ];
    }
    if (appliedFilters.proceduresSelected.length === 0) {
        appliedFilters.proceduresSelected = [
            {
                description: 'All',

                procedureId: 'procedureIdAll',
                isChecked: true,
            },
            ...appliedFilters.proceduresSelected,
        ];
    }

    const orders = useSelector(
        (state) => state.ordersReducer.cardData.orderData,
        shallowEqual
    );
    const userFilters = useSelector(
        (state) => state.filterReducer.userFilters,
        shallowEqual
    );

    const visibleDateRange = useSelector(
        (state) => state.filterReducer.visibleDateRange
    );

    const calendarView = useSelector(
        (state) => state.filterReducer.calendarView
    );

    const selectedCalendarView = useSelector(
        (state) => state.filterReducer.selectedCalendarView,
        shallowEqual
    );

    const defaultCalendarView = useSelector(
        (state) => state.appliedFiltersReducer.defaultCalendarView,
        shallowEqual
    );

    const displayFilters = useSelector(
        (state) => state.appliedFiltersReducer.displayFilters,
        shallowEqual
    );

    const refinedFiltersLoading = useSelector(
        (state) => state.refinedFiltersReducer.loading
    );

    useEffectWithErrorLogging(() => {
        if (expandedViews) {
            setExpandedViewsLocal({ ...expandedViews });
        }
    }, [expandedViews]);

    useEffectWithErrorLogging(() => {
        addCheckedStatusToAllFilters();
    }, [
        // selectedCalendarView,
        defaultCalendarView,
        refinedFilters,
        appliedFilters,
        // expandedViews,
        orders,
    ]);

    useEffectWithErrorLogging(() => {
        let basicFilters = appliedFilters.basicFilters
            ? appliedFilters.basicFilters
            : [];
        let salesHierarchies = appliedFilters.salesHierarchies
            ? appliedFilters.salesHierarchies
            : [];
        setAllCalendarViewFilters([...basicFilters, ...salesHierarchies]);
    }, [appliedFilters]);

    useEffectWithErrorLogging(() => {
        // call backend api
    }, [selectedCalendarView]);

    useApplyButtonStatus({
        allFiltersWithStatus,
        displayFilters,
        checkOrderCondition,
        setApplyButton,
    });

const setSelectedCalendarView = (view) =>
    setSelectedCalendarViewhandler({
        dispatch,
        setSelectedCalendarViewRedux,
        setFilters,
        getCardData,
        getListData,
        calendarView,
        userFilters,
        visibleDateRange,
        selectedDate,
        getPreviousDate,
        convertDateToISOString,
        addDaysToDate,
        isStartDateLessThanEndDate,
        setViewDataEmpty,
        getViewData,
        getRefinedFilters,
        view
    });

    // eslint-disable-next-line no-unused-vars
    const setDefaultCalendarView = (view) => {
        handleSetAsDefaultView();
    };

    const addCheckedStatusToAllFilters = () => {
        setAllFiltersWithStatus({
            ...allFiltersWithStatus,
            orderTypesFilter: addCheckedToFilter(
                refinedFilters.orderTypesFilter,
                appliedFilters.orderTypesSelected,
                'orderTypeCode'
            ),
            orderStatusFilter: addCheckedToFilter(
                refinedFilters.orderStatusFilter,
                appliedFilters.orderStatusesSelected,
                'statusCode'
            ),
            accountFilter: addCheckedToFilter(
                refinedFilters.accountFilter,
                appliedFilters?.accountsSelected,
                'accountId'
            ),
            procedureFilter: addCheckedToFilter(
                refinedFilters.procedureFilter,
                appliedFilters.proceduresSelected,
                'procedureId'
            ),
            physicianFilter: addCheckedToFilter(
                refinedFilters.physicianFilter,
                appliedFilters.physiciansSelected,
                'physicianId'
            ),
        });
    };

    const addCheckedToFilter = (filterList, appliedList, paramToCompare) => {
        filterList.forEach((item) => {
            let obj =
                appliedList.find(
                    (object) => object[paramToCompare] === item[paramToCompare]
                ) || {};
            if (Object.keys(obj).length !== 0) {
                item.isChecked = true;
            } else {
                item.isChecked = false;
            }
        });
        return filterList;
    };

    const clearCheckBoxes = (filters, isOrderConditionfilter) => {
        if (isOrderConditionfilter === 'OrderCondition') {
            filters.forEach((filter) => {
                filter.selected =
                    filter.name === t('calendar.filterResultsPanel.assigned');
            });
            return filters;
        }
        filters.forEach((filter) => {
            filter.isChecked = false;
        });
        return filters;
    };

    // Builds a cleared copy immutably so callers can both apply state AND
    // consume the fresh value in the same tick (avoids stale-closure reads).
    const buildClearedFilters = () => ({
        ...allFiltersWithStatus,
        orderTypesFilter: allFiltersWithStatus.orderTypesFilter.map((f) => ({
            ...f,
            isChecked: false,
        })),
        orderStatusFilter: allFiltersWithStatus.orderStatusFilter.map((f) => ({
            ...f,
            isChecked: false,
        })),
        accountFilter: allFiltersWithStatus.accountFilter.map((f) => ({
            ...f,
            isChecked: false,
        })),
        procedureFilter: allFiltersWithStatus.procedureFilter.map((f) => ({
            ...f,
            isChecked: false,
        })),
        physicianFilter: allFiltersWithStatus.physicianFilter.map((f) => ({
            ...f,
            isChecked: false,
        })),
        orderConditionFilter: allFiltersWithStatus.orderConditionFilter.map(
            (f) => ({
                ...f,
                selected:
                    f.name === t('calendar.filterResultsPanel.assigned'),
            })
        ),
    });

    const clearAllCheckboxesAndFilters = () => {
        try {
            const cleared = buildClearedFilters();
            setAllFiltersWithStatus(cleared);
            return cleared;
        } catch (error) {
            logErrorToConsole(error);
            return null;
        }
    };

    const updateExpandedViews = (componentName) => {
        setExpandedViewsLocal({
            ...expandedViewsLocal,
            [componentName.view]: componentName.value,
        });
    };

    const handleCheckboxChange = (event, filters, paramName) => {
        filters.forEach((filter) => {
            if (filter[paramName] === event.target.value) {
                filter.isChecked = event.target.checked;

                //executed when user selecting items exclude 'all'\
                let selectedItemValue = event.target.value;
                let allValueFromFilters = filters[0][paramName];

                if (
                    selectedItemValue !== allValueFromFilters &&
                    event.target.checked === true
                ) {
                    filters[0].isChecked = false;
                    filter.isChecked = event.target.checked;
                }

                //executed when user selected 'all' checkbox
                if (
                    (event.target.value === allValueFromFilters &&
                        event.target.checked === true) ||
                    (filters || []).filter((it) => it.isChecked).length == 0
                ) {
                    filters.forEach((filter) => {
                        filter[paramName] !== allValueFromFilters
                            ? (filter.isChecked = false)
                            : (filter.isChecked = true);
                    });
                }
            }
        });
        setAllFiltersWithStatus({
            ...allFiltersWithStatus,
            [event.target.name]: filters,
        });
    };

    // eslint-disable-next-line no-unused-vars
    const onCheckBoxChange = (event, filterName) => {
        switch (event.target.name) {
            case 'accountFilters':
                handleCheckboxChange(
                    event,
                    refinedFilters.accountFilter,
                    'accountId'
                );
                return;
            case 'OrderTypeView':
                handleCheckboxChange(
                    event,
                    refinedFilters.orderTypesFilter,
                    'orderTypeCode'
                );
                return;
            case 'orderStatusFilters':
                handleCheckboxChange(
                    event,
                    refinedFilters.orderStatusFilter,
                    'statusCode'
                );
                return;
            case 'physiciansFilters':
                handleCheckboxChange(
                    event,
                    refinedFilters.physicianFilter,
                    'physicianId'
                );
                return;
            case 'procedureFilters':
                handleCheckboxChange(
                    event,
                    refinedFilters.procedureFilter,
                    'procedureId'
                );
                return;
            default:
                return;
        }
    };

    const resetFilters = () => {
        const cleared = clearAllCheckboxesAndFilters();
        dispatch(setOrderCondition(true));
        setSelectedCalendarView(defaultCalendarView);
        setApplyButton(false);
        return cleared;
    };

    const handleSetAsDefaultView = () => {
        dispatch(
            putFilterOptions({
                fields: 'DEFAULT',
                calendarSelection: selectedCalendarView.id
                    ? selectedCalendarView.id
                    : defaultCalendarView.id,
                assignedFlag: orderCondition,
            })
        );
    };

    const handleApplyFilters = (filtersOverride) => {
        // Prefer the fresh cleared/updated shape passed by the caller so the
        // dispatch below cannot read a stale `allFiltersWithStatus` from closure.
        const filters = filtersOverride || allFiltersWithStatus;
        // Update the views in redux reducer
        dispatch(
            setExpandedFilterViews({
                ...expandedViewsLocal,
            })
        );
        // Update the filters
        dispatch(
            setOrderCondition(
                filters.orderConditionFilter.filter(
                    (item) => item.selected
                )[0].id === 'assignedFlag'
                    ? true
                    : false
            )
        );
        dispatch(
            putFilterOptions({
                fields: 'DEFAULT',
                calendarSelection: defaultCalendarView.id,
                filteredOrderTypes: filters.orderTypesFilter
                    .filter(
                        (item) => item.orderTypeName !== 'All' && item.isChecked
                    )
                    .reduce((accumulator, currentValue) => {
                        return accumulator
                            ? `${accumulator},${currentValue.orderTypeCode}`
                            : currentValue.orderTypeCode;
                    }, ''),
                filteredAccounts: filters.accountFilter
                    .filter((item) => item.name !== 'All' && item.isChecked)
                    .reduce((accumulator, currentValue) => {
                        return accumulator
                            ? `${accumulator},${currentValue.accountId}`
                            : currentValue.accountId;
                    }, ''),
                filteredOrderStatuses: filters.orderStatusFilter
                    .filter(
                        (item) => item.description !== 'All' && item.isChecked
                    )
                    .reduce((accumulator, currentValue) => {
                        return accumulator
                            ? `${accumulator},${currentValue.statusCode}`
                            : currentValue.statusCode;
                    }, ''),
                filteredPhysicians: filters.physicianFilter
                    .filter((item) => item.name !== 'All' && item.isChecked)
                    .reduce((accumulator, currentValue) => {
                        return accumulator
                            ? `${accumulator},${currentValue.physicianId}`
                            : currentValue.physicianId;
                    }, ''),
                filteredProcedures: filters.procedureFilter
                    .filter(
                        (item) => item.description !== 'All' && item.isChecked
                    )
                    .reduce((accumulator, currentValue) => {
                        return accumulator
                            ? `${accumulator},${currentValue.procedureId}`
                            : currentValue.procedureId;
                    }, ''),
                assignedFlag:
                    filters.orderConditionFilter.filter(
                        (item) => item.selected
                    )[0].id === 'assignedFlag'
                        ? true
                        : false,
            })
        );
        setApplyButton(false);
    };

    const setSelectedCalendarViewWithMoreActions = (filterItem) => {
        var updatedAllCalendarViewFilters = allCalendarViewFilters.map(
            (item) => {
                if (item.id != filterItem.id) {
                    return { ...item, selected: false };
                } else return { ...item, selected: true };
            }
        );
        setAllCalendarViewFilters(updatedAllCalendarViewFilters);

        setSelectedCalendarView(filterItem);
    };

    const setSelectOrderCondition = (filterItem) => {
        if (
            (orderCondition && filterItem.id === 'unAssignedFlag') ||
            (!orderCondition && filterItem.id === 'assignedFlag')
        ) {
            setCheckOrderCondition(true);
        } else {
            setCheckOrderCondition(false);
        }
        var updatedOrderConditionFilters =
            allFiltersWithStatus.orderConditionFilter.map((item) => {
                if (item.id != filterItem.id) {
                    return { ...item, selected: false };
                } else return { ...item, selected: true };
            });
        setAllFiltersWithStatus({
            ...allFiltersWithStatus,
            orderConditionFilter: updatedOrderConditionFilters,
        });
    };

    const checkDefaultCalendarView = () => {
        if (
            !selectedCalendarView.id ||
            selectedCalendarView.id === defaultCalendarView.id
        ) {
            return false;
        } else {
            return true;
        }
    };

    return (
        <FilterBlock>
            <FilterWrapperMain className="FilterWrapperMain" bannerHeight={props.bannerHeight} viewportHeight={viewportHeight}>
                <FilterHeader>
                    <FilterHeading>{t('common.filtersLabel')}</FilterHeading>
                    <div
                        onClick={() => {
                            try {
                                const cleared = resetFilters();
                                handleApplyFilters(cleared);
                            } catch (error) {
                                logErrorToConsole(error);
                            }
                        }}
                    >
                        <Reset>{t('common.resetLink')}</Reset>
                    </div>
                </FilterHeader>
                <FilterContentMain
                    scrollBarWidth={'7px'}
                    scrollBarBackgroundColor={'#afafaf'}
                    scrollBarBorderRadius={'10px'}
                    scrollbarHeight={'7rem'}
                    scrollBarBackGroundColorOnHover={'#afafaf'}
                    mobileDeviceScrollBarDisplay={'block'}
                    mediumDeviceScrollBarDisplay={'block'}
                >
                    <FilterView
                        viewFilterName={'CalendarView'}
                        header={t(FILTER_DROPDOWN_HEADERS[0].value)}
                        viewFiltersLists={allCalendarViewFilters}
                        defaultViewFilter={defaultCalendarView}
                        setDefaultCalendarView={setDefaultCalendarView}
                        isExpanded={expandedViewsLocal.CalendarView}
                        updateExpandedViews={updateExpandedViews}
                        selectedViewFilter={selectedCalendarView}
                        setSelectedViewFilter={
                            setSelectedCalendarViewWithMoreActions
                        }
                        setDefaultAction={true}
                        showDefault={true}
                        showDot={checkDefaultCalendarView()}
                    />
                    {refinedFiltersLoading ? (
                        <Spinner
                            id="common-filters-filter-loadingSpinner"
                            animation="border"
                            variant="primary"
                            small
                        ></Spinner>
                    ) : (
                        <>
                            <CommonFilter
                                key={t(FILTER_DROPDOWN_HEADERS[5].value)}
                                header={t(FILTER_DROPDOWN_HEADERS[5].value)}
                                filters={allFiltersWithStatus.orderTypesFilter}
                                onCheckBoxChange={onCheckBoxChange}
                                isExpanded={expandedViewsLocal.OrderTypeView}
                                updateExpandedViews={updateExpandedViews}
                                allFiltersWithStatus={allFiltersWithStatus}
                                checkBoxName={'OrderTypeView'}
                                view={'OrderTypeView'}
                                notGroupOrderStatus={true}
                                isOrderType = {true}
                            />
                            <CommonFilter
                                header={t(FILTER_DROPDOWN_HEADERS[1].value)}
                                filters={allFiltersWithStatus.orderStatusFilter}
                                onCheckBoxChange={onCheckBoxChange}
                                isExpanded={expandedViewsLocal.OrderStatusView}
                                updateExpandedViews={updateExpandedViews}
                                allFiltersWithStatus={allFiltersWithStatus}
                                isOrderStatus={true}
                            />
                            <CommonFilter
                                isAccount = {true}
                                header={t(FILTER_DROPDOWN_HEADERS[3].value)}
                                filters={allFiltersWithStatus.accountFilter}
                                onCheckBoxChange={onCheckBoxChange}
                                isExpanded={expandedViewsLocal.AccountView}
                                updateExpandedViews={updateExpandedViews}
                                allFiltersWithStatus={allFiltersWithStatus}
                            />
                            <CommonFilter
                                isPhysician = {true}
                                header={t(FILTER_DROPDOWN_HEADERS[2].value)}
                                filters={allFiltersWithStatus.physicianFilter}
                                onCheckBoxChange={onCheckBoxChange}
                                isExpanded={expandedViewsLocal.PhysiciansView}
                                updateExpandedViews={updateExpandedViews}
                                allFiltersWithStatus={allFiltersWithStatus}
                            />
                            <CommonFilter
                                isProcedure = {true}
                                header={t(FILTER_DROPDOWN_HEADERS[4].value)}
                                filters={allFiltersWithStatus.procedureFilter}
                                onCheckBoxChange={onCheckBoxChange}
                                isExpanded={expandedViewsLocal.ProcedureView}
                                updateExpandedViews={updateExpandedViews}
                                allFiltersWithStatus={allFiltersWithStatus}
                                marginBottom={'10px'}
                            />
                            <FilterView
                                viewFilterName={'OrderCondition'}
                                header={t(
                                    'orders.orderListViewFilterDropDown.orderCondition'
                                )}
                                viewFiltersLists={
                                    allFiltersWithStatus.orderConditionFilter
                                }
                                isExpanded={expandedViewsLocal.OrderCondition}
                                updateExpandedViews={updateExpandedViews}
                                // selectedViewFilter={selectedCalendarView}
                                setSelectedViewFilter={setSelectOrderCondition}
                                showDot={
                                    allFiltersWithStatus.orderConditionFilter[1]
                                        .selected
                                }
                                marginBottom={'70px'}
                            />
                        </>
                    )}
                    <EmptyBox></EmptyBox>
                    <BottomNavigation
                        justifyContent={'space-evenly'}
                        opacity={'1'}
                        padding={'11px'}
                        position={'absolute'}
                    >
                        <Button
                        id={'common-filter-closeButton'}
                            show={true}
                            variant={ButtonStyles?.secondary}
                            width={'40%'}
                            height={'38px'}
                            clicked={() => {
                                props.onClose();
                            }}
                        >
                            <TextBold color={'#1010EB'}>
                                {t('common.closeButton')}
                            </TextBold>
                        </Button>
                        <Button
                        id={'common-filter-applyButton'}
                            show={true}
                            disabled={!applyButton || refinedFiltersLoading}
                            variant={applyButton ? ButtonStyles?.primary : (!applyButton || refinedFiltersLoading) ? ButtonStyles.disabled : ButtonStyles.disabled}
                            width={'40%'}
                            height={'38px'}
                            clicked={() => {
                                try {
                                    handleApplyFilters();
                                    props.onClose();
                                } catch (error) {
                                    logErrorToConsole(error);
                                }
                            }}
                        >
                            <TextBold color={'#FFFF'}>
                                {/* // check this color */}
                                {t('common.applyButton')}
                            </TextBold>
                        </Button>
                    </BottomNavigation>
                </FilterContentMain>
            </FilterWrapperMain>
        </FilterBlock>
    );
};

export default Filters;
